import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import AdminLayout from './components/admin/AdminLayout';
import AuthGuard from './components/admin/AuthGuard';
import AdminLogin from './pages/admin/Login';
import Assistant from './components/Assistant';
import NotFound from './pages/NotFound';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Profile from './pages/Profile';

// Public Pages
import Home from './pages/Home';
import Cities from './pages/Cities';
import Districts from './pages/Districts';
import Neighborhoods from './pages/Neighborhoods';
import TaxiStands from './pages/TaxiStands';
import FareCalculator from './pages/FareCalculator';
import Favorites from './pages/Favorites';
import HowItWorks from './pages/HowItWorks';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Map from './pages/Map';

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard';
import AdminCities from './pages/admin/Cities';
import AdminDistricts from './pages/admin/Districts';
import AdminNeighborhoods from './pages/admin/Neighborhoods';
import AdminTaxiStands from './pages/admin/TaxiStands';
import AdminReviews from './pages/admin/Reviews';
import AdminSEOSettings from './pages/admin/SEOSettings';
import BulkDistrictImport from './pages/admin/BulkDistrictImport';
import BulkNeighborhoodImport from './pages/admin/BulkNeighborhoodImport';
import BulkMultiDistrictImport from './pages/admin/BulkMultiDistrictImport';
import BulkTaxiImport from './pages/admin/BulkTaxiImport';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          {/* Auth Routes */}
          <Route path="giris" element={<Login />} />
          <Route path="kayit-ol" element={<Register />} />
          <Route path="profil" element={<Profile />} />
          {/* Other Routes */}
          <Route path="sehirler" element={<Cities />} />
          <Route path="il/:citySlug" element={<Districts />} />
          <Route path="ilce/:citySlug/:districtSlug" element={<Neighborhoods />} />
          <Route path="mahalle/:citySlug/:districtSlug/:neighborhoodSlug" element={<TaxiStands />} />
          <Route path="taksi-ucreti-hesaplama" element={<FareCalculator />} />
          <Route path="favoriler" element={<Favorites />} />
          <Route path="nasil-calisir" element={<HowItWorks />} />
          <Route path="hakkimizda" element={<About />} />
          <Route path="iletisim" element={<Contact />} />
          <Route path="gizlilik" element={<Privacy />} />
          <Route path="kullanici-sozlesmesi" element={<Terms />} />
          {/* Eski URL'den yeni URL'ye yönlendirme */}
          <Route path="ucret-hesapla" element={<Navigate to="/taksi-ucreti-hesaplama" replace />} />
        </Route>

        {/* Map Route - Harita sayfası ayrı layout kullanacak */}
        <Route path="/harita" element={<Map />} />

        {/* Admin Login */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Protected Admin Routes */}
        <Route
          path="/admin"
          element={
            <AuthGuard>
              <AdminLayout />
            </AuthGuard>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="cities" element={<AdminCities />} />
          <Route path="districts" element={<AdminDistricts />} />
          <Route path="districts/import" element={<BulkDistrictImport />} />
          <Route path="districts/multi-import" element={<BulkMultiDistrictImport />} />
          <Route path="neighborhoods" element={<AdminNeighborhoods />} />
          <Route path="neighborhoods/import" element={<BulkNeighborhoodImport />} />
          <Route path="taxi-stands" element={<AdminTaxiStands />} />
          <Route path="taxi-stands/import" element={<BulkTaxiImport />} />
          <Route path="reviews" element={<AdminReviews />} />
          <Route path="seo" element={<AdminSEOSettings />} />
        </Route>

        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* AI Assistant */}
      <Assistant />
    </Router>
  );
}